import { http } from './http';
import { ROUTES } from './config';
import type { AuthUser, Role } from '../types/domain';

/** User management — SUPER-ADMIN only (gateway blocks non-admins at the edge). */
export const usersApi = {
  list(role?: Role): Promise<AuthUser[]> {
    const q = role ? `?role=${encodeURIComponent(role)}` : '';
    return http.get(`${ROUTES.auth.users}${q}`);
  },

  get(id: string): Promise<AuthUser> {
    return http.get(`${ROUTES.auth.users}/${id}`);
  },

  update(id: string, body: { name?: string; roles?: Role[]; active?: boolean }): Promise<void> {
    return http.put(`${ROUTES.auth.users}/${id}`, body);
  },

  remove(id: string): Promise<void> {
    return http.delete(`${ROUTES.auth.users}/${id}`);
  },
};
